/**
 * 订单列表
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import {Tabs, Spin, Tooltip, Checkbox, Badge, Space,} from "antd";
import PageCommon from  "@components/PageCommon/PageCommon";
import {symbolMoneyUtil} from '@utils/utils';
import {Link} from "react-router-dom";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@/components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import dayjs from 'dayjs';
import ExportBtn from '@components/ExportBtn/index'
import ExportData from "@pages/DataStatistics/Sale/component/ExportData";
import LogisticsAndCabinetSwitch from "@/components/Logistics/LogisticsAndCabinetSwitch";
import BatchPickUpPoDrawer from "@/components/batchPickUpPoDrawer/batchPickUpPoDrawer";
import ModalOrderDetail from "@components/ModalOrderDetails/ModalOrderDetail";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import IconDirectPo from "@components/Icon/IconDirectPo/IconDirectPo";//直达图标
import VipLvLevel from "@components/Icon/vip-badge/vipLvLevel";
import Locale from "@utils/locale";
import "./OrderSale.less";
let locale = Locale.current();
class OrderSale extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchFormOptionsOne:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'status',
                    cnTitle:'订单状态',
                    cnTitleId:'DingDanZhuangTai',
                    cnPlaceholder:'请选择订单状态',
                    cnPlaceholderId:'QingXuanZeDingDanZhuangTai',
                    type:'Enum',
                    // enumClass:'sale_po_status',
                    enumClass:'sale_po_ddp_status_buyer',
                    hiddenLabel:true,
                    width:  locale === "ru" ? 430 : ( locale === "en" ? 350:250),
                    excludeValue:['-10','110'],
                    allowClear:true,
                },
                {
                    name:'poCode',
                    cnTitle:'PO订单',
                    cnTitleId:'PODingDan',
                    cnPlaceholder:'请输入订单号',
                    cnPlaceholderId:'QingShuRuDingDanHao',
                    hiddenLabel:true,
                    width:200,
                },
                {
                    name:'buyerCode',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    cnPlaceholder:'请输入采购商编码或名称',
                    cnPlaceholderId:'QingShuRuCaiGouShangBianMaHuoMingCheng',
                    hiddenLabel:true,
                },
                {
                    name:'containerCode',
                    cnTitle:'柜号',
                    cnTitleId:'GuiHao',
                    cnPlaceholder:'请输入柜号',
                    cnPlaceholderId:'QingShuRuJuHao',
                    hiddenLabel:true,
                },
            ],
            searchFormOptionsTwo:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'poCode',
                    cnTitle:'PO订单',
                    cnTitleId:'PODingDan',
                    cnPlaceholder:'请输入订单号',
                    cnPlaceholderId:'QingShuRuDingDanHao',
                    hiddenLabel:true,
                    width:200,
                },
                {
                    name:'buyerCode',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    cnPlaceholder:'请输入采购商编码或名称',
                    cnPlaceholderId:'QingShuRuCaiGouShangBianMaHuoMingCheng',
                    hiddenLabel:true,
                },
                {
                    name:'containerCode',
                    cnTitle:'柜号',
                    cnTitleId:'GuiHao',
                    cnPlaceholder:'请输入柜号',
                    cnPlaceholderId:'QingShuRuJuHao',
                    hiddenLabel:true,
                },
            ],
            searchFormOptionsThree:[
                {
                    name:'time',
                    cnTitle:'登记时间',
                    cnTitleId:'DengJiShiJian',
                    // cnPlaceholder:'请输入订单号或登记号',
                    // cnPlaceholderId:'QingShuRuDingDanHaoHhuoDengJiHao',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['registerBeginTime','registerEndTime'],
                    // hiddenLabel:true,
                    type:'DateRangePicker',
                    width:300,
                },
                {
                    name:'searchParamOne',
                    cnTitle:'PO订单',
                    cnTitleId:'PODingDan',
                    cnPlaceholder:'请输入订单号或登记号',
                    cnPlaceholderId:'QingShuRuDingDanHaoHhuoDengJiHao',
                    hiddenLabel:true,
                    // width:150,
                },
                {
                    name:'searchParamTwo',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    cnPlaceholder:'请输入客户编码或操作人',
                    cnPlaceholderId:'QingShuRuKeHuBianMaHuoCaoZuoRen',
                    hiddenLabel:true,
                },
            ],
            columns:[
                {
                    cnTitle: 'PO订单',
                    dataIndex: 'poCode',
                    cnTitleId: 'PODingDan',
                    width:200,
                    render:(poCode, record, index) => (<>
                        <p>
                            <ModalOrderDetail id={record.poId}>
                                {record.noCertificateSplit==1?<Tooltip title={__getServerLanguage('ZhongGuoZhiFaDingDan')}><span className={"ml_4"}>
                                            <IconDirectPo size={18}></IconDirectPo>
                                        </span>
                                </Tooltip>:null} <span className={"fw_700 black89 cursor-p"}>{poCode}</span>
                            </ModalOrderDetail>
                        </p>
                        {record.code&&<div>
                            <LogisticsAndCabinetSwitch poId = {record.poId}
                                poCode={record.poCode}
                                containerCode={record.code}
                                cabinetNum={record.cabinetNum}
                                logisticsData={record.pubOrderTrackVOS}
                            />
                        </div>}
                    </>)
                },
                {
                    cnTitle: '客户',
                    cnTitleId: 'KeHu',
                    dataIndex: 'buyerCode',
                    width:200,
                    render:(text, record, index) => (<>
                        <div className={"flex-item"}>
                            <Link className="black66" to={`/customer/detail?id=${record.buyerId}`} target={"_blank"}>{record.buyerCode}</Link>
                            {record.pointLevel&&record.pointLevel>0?<span className={"spanLevel ml_4"}><VipLvLevel grade={record.pointLevel} width={24} /></span>:null}
                            {record.isKaBuyer=="1"?<span className={"ml_4 kaLabel"}>KA</span>:null}
                        </div>
                        <p className={"black45 mt_4"}>
                            <Tooltip placement="right" title={Lang({id:"ChuangJianShiJian", default:"创建时间"})}>
                                <span className={"ri-time-line"} />
                                <span className={"font_12 ml_4"}>{record.createTime? dayjs(record.createTime).format("YYYY-MM-DD"): "-"}</span>
                            </Tooltip>
                        </p>
                    </>),
                },
                {
                    cnTitle: '状态',
                    dataIndex: 'orderStatus',
                    cnTitleId: 'QuanBuZhuangTai',
                    render: (orderStatus, record) => {
                        return(<div>
                            <span className={`labelStatus${(record.depositPayStatus=="TO_BE_CONFIRM"||record.balancePayStatus=="TO_BE_CONFIRM")?" labelStatusRed":""}`}>
                            {record.isChange==1&&<Badge status="error" />}{orderStatus}
                            </span>
                            {/* kizStatus 10:应用 20:流通中 */}
                            {record.kizFlagVO&&record.kizFlagVO.kizStatus?<div className={`fw_700 mt_2 font_12 pl_8${record.kizFlagVO.kizStatus=='10'?" color_FB7321":" color-green2"}`}>{record.kizFlagVO.kizStatusName}</div>:null}
                        </div>)},
                    width:200,
                },
                {
                    cnTitle: '订单金额',
                    dataIndex: 'totalPrice',
                    cnTitleId: 'DingDanJinE',
                    render:(text, record, index) => (<>
                        <div className={"black66 fw_700 font_14"}>
                            {symbolMoneyUtil(record.totalPrice, record.currencySymbol)}
                        </div>
                        {record.deposit?<Tooltip placement="right" title={Lang({id:"DingJin", default:"定金"})}>
                            <span className={"black45 font_12"}><i className={"ri-dual-sim-1-fill mr_4 font_14"} />
                                {symbolMoneyUtil(record.deposit, record.currencySymbol)}
                            </span>
                        </Tooltip>:null}
                        {record.balance?<div className={"black45 font_12"}>
                            <Tooltip placement="right" title={Lang({id:"WeiKuan", default:"尾款"})}>
                                <span><i className={"ri-dual-sim-2-fill mr_4 font_14"} />
                                    {symbolMoneyUtil(record.balance, record.currencySymbol)}
                                </span>
                            </Tooltip>
                        </div>:null}
                    </>),
                    width:150,
                },
                {
                    cnTitle: '退款金额',
                    dataIndex: 'cancelRefundTotal',
                    cnTitleId: 'TuiKuanJinE',
                    render:(text, record, index) => (
                        <p>
                            {record.cancelRefundTotal?symbolMoneyUtil(record.cancelRefundTotal, record.currencySymbol):'-'}
                        </p>
                    ),
                    width:150,
                },
                {
                    cnTitle: '收货人信息³',
                    dataIndex: 'consignee',
                    cnTitleId: 'ShouHuoRen',
                    width:300,
                    render:(text, record, index) => (
                        <Space direction="vertical ">
                            <div>{record.buyerName}</div>
                            <div className="black45">{record.buyAccountMobile}</div>
                        </Space>
                    )
                },
                {
                    cnTitle: '预计到达',
                    dataIndex: 'arrivalPortDate',
                    cnTitleId: 'YuJiDaoGang',
                    width:150,
                    render:(text, record, index) => (<>
                        <p>{record.arrivalPortDate?dayjs(record.arrivalPortDate).format("YYYY-MM-DD"):'-'}</p>
                        <p><i className={"ri-hotel-fill mr_2 font_16 black45 mr_4"} />{record.transitCityName}</p>
                    </>),
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 250,
                    fixed:'right',
                    // align:"right",
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => ( <div className={"flex-item"} style={{justifyContent:"flex-end"}}>

                        {record.invoiceFileUrl&&<span className={"mr_8"}><AuthBtn icon={"ri-file-text-line"}
                                                         tips = {Lang({id:"FuKuanPingZheng",default:"付款凭证"})}
                                                         onClick={()=>window.open(record.invoiceFileUrl,'_blank')}/></span>}

                        {/* 提货预约 */}
                        {record.noCertificateSplit!=1?<span className={"mr_8"}><BatchPickUpPoDrawer buyerId={record.buyerId} /></span>:null}
                        {/*{record&&record.pubOrderTrackVOS&&record.pubOrderTrackVOS.length>0&&<LogisticsInformation*/}
                            {/*poCode={record.poCode}*/}
                            {/*leftCode={record.code}*/}
                            {/*rightCode={record.cabinetNum} logisticsData={record.pubOrderTrackVOS}/>}*/}
                      <AuthBtn icon={"ri-arrow-right-s-line"}
                               tips = {Lang({id:"XiangQing",default:"详情"})}
                               linkTo={{
                                    pathname: '/order/sale/detail',
                                    search: `?id=${record.poId}`,
                                    state: {id: record.poId}
                               }} />
                    </div>)
                    },
            ],
            columnsReviewed:[
                {
                    cnTitle: 'PO订单',
                    dataIndex: 'poCode',
                    cnTitleId: 'PODingDan',
                    width:200,
                    render:(poCode, record, index) => (<>
                        <p>
                            <ModalOrderDetail id={record.poId}>
                                {record.noCertificateSplit==1?<Tooltip title={__getServerLanguage('ZhongGuoZhiFaDingDan')}><span className={"ml_4"}>
                                            <IconDirectPo size={18}></IconDirectPo>
                                        </span>
                                </Tooltip>:null} <span className={"fw_700 black89 cursor-p"}>{poCode}</span>
                            </ModalOrderDetail>
                        </p>
                        {record.code&&<div>
                            <LogisticsAndCabinetSwitch poId = {record.poId}
                                                       poCode={record.poCode}
                                                       containerCode={record.code}
                                                       cabinetNum={record.cabinetNum}
                                                       logisticsData={record.pubOrderTrackVOS}
                            />
                        </div>}
                    </>)
                },
                {
                    cnTitle: '客户',
                    cnTitleId: 'KeHu',
                    dataIndex: 'buyerCode',
                    width:200,
                    render:(text, record, index) => (<>
                        {/*<Link className="black66" to={`/customer/detail?id=${record.buyerId}`} target={"_blank"}>{record.buyerCode}</Link>*/}
                        <div className={"flex-item"}>
                            <Link className="black66" to={`/customer/detail?id=${record.buyerId}`} target={"_blank"}>{record.buyerCode}</Link>
                            {record.pointLevel&&record.pointLevel>0?<span className={"spanLevel ml_4"}><VipLvLevel grade={record.pointLevel} width={24} /></span>:null}
                            {record.isKaBuyer=="1"?<span className={"ml_4 kaLabel"}>KA</span>:null}
                        </div>
                        <p className={"black45 mt_4"}>
                            <Tooltip placement="right" title={Lang({id:"ChuangJianShiJian", default:"创建时间"})}>
                                <span className={"ri-time-line"} />
                                <span className={"font_12 ml_4"}>{record.createTime? dayjs(record.createTime).format("YYYY-MM-DD"): "-"}</span>
                            </Tooltip>
                        </p>
                    </>),
                },
                {
                    cnTitle: '状态',
                    dataIndex: 'orderStatus',
                    cnTitleId: 'QuanBuZhuangTai',
                    render: (orderStatus, record) => {
                        return(<div>
                            <span className={`labelStatus${(record.statusBuyer=="-10")?" labelStatusRed":""}`}>
                                {record.isChange==1&&<Badge status="error" />}{orderStatus}
                            </span>
                            {record.kizFlagVO&&record.kizFlagVO.kizStatus?<div className={`fw_700 mt_2 font_12 pl_8${record.kizFlagVO.kizStatus=='10'?" color_FB7321":" color-green2"}`}>{record.kizFlagVO.kizStatusName}</div>:null}
                        </div>)},
                    width:200,
                },
                {
                    cnTitle: '订单金额',
                    dataIndex: 'totalPrice',
                    cnTitleId: 'DingDanJinE',
                    render:(text, record, index) => (<>
                        <div className={"black66 fw_700 font_14"}>
                            {symbolMoneyUtil(record.totalPrice, record.currencySymbol)}
                        </div>
                        {record.deposit?<Tooltip placement="right" title={Lang({id:"DingJin", default:"定金"})}>
                            <span className={"black45 font_12"}><i className={"ri-dual-sim-1-fill mr_4 font_14"} />
                                {symbolMoneyUtil(record.deposit, record.currencySymbol)}
                            </span>
                        </Tooltip>:null}
                        {record.balance?<div className={"black45 font_12"}>
                            <Tooltip placement="right" title={Lang({id:"WeiKuan", default:"尾款"})}>
                                <span><i className={"ri-dual-sim-2-fill mr_4 font_14"} />
                                    {symbolMoneyUtil(record.balance, record.currencySymbol)}
                                </span>
                            </Tooltip>
                        </div>:null}
                    </>),
                    width:150,
                },
                {
                    cnTitle: '退款金额',
                    dataIndex: 'cancelRefundTotal',
                    cnTitleId: 'TuiKuanJinE',
                    render:(text, record, index) => (
                        <p>
                            {record.cancelRefundTotal?symbolMoneyUtil(record.cancelRefundTotal, record.currencySymbol):'-'}
                        </p>
                    ),
                    width:150,
                },
                {
                    cnTitle: '收货人信息³',
                    dataIndex: 'consignee',
                    cnTitleId: 'ShouHuoRen',
                    width:300,
                    render:(text, record, index) => (
                        <Space direction="vertical ">
                            <div>{record.buyerName}</div>
                            <div className="black45">{record.buyAccountMobile}</div>
                        </Space>
                    )
                },
                {
                    cnTitle: '预计到达',
                    dataIndex: 'arrivalPortDate',
                    cnTitleId: 'YuJiDaoGang',
                    width:150,
                    render:(text, record, index) => (<>
                        <p>{record.arrivalPortDate?dayjs(record.arrivalPortDate).format("YYYY-MM-DD"):'-'}</p>
                        <p><i className={"ri-hotel-fill mr_2 font_16 black45 mr_4"} />{record.transitCityName}</p>
                    </>),
                },
                {
                    cnTitle: '完成时间',
                    dataIndex: 'doneTime',
                    width:150,
                    cnTitleId: 'WanChengShiJian',
                    render:(text, record, index) => (
                        <p>{record.doneTime?dayjs(record.doneTime).format("YYYY-MM-DD"):'-'}</p>
                    )
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    fixed:'right',
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<AuthBtn icon={"ri-arrow-right-s-line"}
                                 tips = {Lang({id:"XiangQing",default:"详情"})}
                                 linkTo={{
                                     pathname: '/order/sale/detail',
                                     search: `?id=${record.poId}`,
                                     state: {id: record.poId}
                                 }} />)},
            ],
            columnsCancel:[
                {
                    cnTitle: '客户',
                    cnTitleId: 'KeHu',
                    dataIndex: 'buyerNumber',
                    render:(buyerNumber, record, index) => (<>
                        <div className={"flex-item"}>
                            <span>{buyerNumber}</span>
                            {record.pointLevel&&record.pointLevel>0?<span className={"spanLevel ml_4"}><VipLvLevel grade={record.pointLevel} width={24} /></span>:null}
                            {record.isKaBuyer=="1"?<span className={"ml_4 kaLabel"}>KA</span>:null}
                        </div>

                    </>),
                },
                {
                    cnTitle: '登记时间',
                    dataIndex: 'registerTime',
                    cnTitleId: 'DengJiShiJian',
                    render:(registerTime => <p>{registerTime ? dayjs(registerTime).format("YYYY-MM-DD") : "-"}</p>)
                },
                {
                    cnTitle: '单号',
                    dataIndex: 'orderNumber',
                    cnTitleId: 'DanHao',
                },
                {
                    cnTitle: '订单编号',
                    dataIndex: 'contactOrder',
                    cnTitleId: 'GuanLianDanHao',
                },
                {
                    cnTitle: '数量',
                    dataIndex: 'deposit',
                    cnTitleId: 'ShuLiang',
                    render:(text, record, index) => (
                        <p className="con1-txt fw_700">
                            {record.skuNum}
                            {__getServerLanguage("Kuan")}，{record.quantity}
                            {__getServerLanguage("Xiang")}
                        </p>
                    )
                },
                {
                    cnTitle: '操作人',
                    dataIndex: 'currentUser',
                    cnTitleId: 'CaoZuoRen',
                },

                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<><AuthBtn icon={"ri-arrow-right-s-line"}
                                                             tips = {Lang({id:"XiangQing",default:"详情"})}
                                                             linkTo={`/order/cancelRecord/details?id=${record.id}`} />
                        </>)},
            ],
            auditStatus:'1',//默认 1:进行中 2:已完成
            total: 0,
            selectSeven:false, //是否勾选 7天

        }
    }
    /**
     * 改变状态
     **/
    changeTab(activeKey){
        this.setState({
            auditStatus:activeKey
        },()=>{
            switch (activeKey) { // 已加载组件 更新点击项 时 重新搜索内容
                case '3':
                   if(this.onRefChildCancleTab){
                       this.onRefChildCancleTab.handleFetch(1,{},true);
                   }
                   break
                case '2':
                    if(this.onRefTabChildTwo){
                        this.onRefTabChildTwo.handleFetch(1,{},true);
                    }
                    break
                default:
                    if(this.onRefTabChildOne){
                        this.onRefTabChildOne.handleFetch(1,{},true);
                    }
            }
        })
    }
    /**
     * 勾选七天
     * */
    onChangeSeven(dat){
        const {checked}= dat.target;
        this.setState({
            selectSeven: checked
        },()=>{
            this.onRefTabChildOne.handleFetch(1,{},true)
        })
    }
    /**
     * 勾选 中国直发订单
     * */
    onChangeNoCertificateSplit(dat){
        const {checked}= dat.target;
        this.setState({
            noCertificateSplit: checked
        },()=>{
            this.onRefTabChildOne.handleFetch(1,{},true)
        })
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    onRefTabTwo = (ref) =>  this.onRefTabChildTwo = ref;
    onRefCancelTab = (ref) =>  this.onRefChildCancleTab = ref;
    /**
     * 重置
     * */
    searchReset(){
        this.setState({
            selectSeven: false,
            noCertificateSplit:""
        },()=>this.onRefTabChildOne.handleFetch(1,{},false))
    }
    fetchCallBack(res={}){
        this.onRefPageCommonChild.isShowTop();
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    componentDidMount() {}
    componentWillMount() {

    }
    render(){
        const { loading,searchFormOptionsOne,columns,auditStatus,columnsReviewed, searchFormOptionsThree,searchFormOptionsTwo,columnsCancel,selectSeven,noCertificateSplit} = this.state;
        const setRightOne =(<div className={'margin-bottom-10'}>
            <Checkbox checked={selectSeven}
                      onChange={(e)=>this.onChangeSeven(e)}>{Lang({id:'Jin3TianYouBianHuaDingDan',default:'近3天有变化订单'})}</Checkbox>
            <Checkbox checked={noCertificateSplit}
                      onChange={(e)=>this.onChangeNoCertificateSplit(e)}>{Lang({id:'ZhongGuoZhiFa',default:'中国直发'})}</Checkbox>
            <ExportBtn authName="Order-Sale-Export-Button" onClick={() => {this.setState({showExportModal: true})}}></ExportBtn>
        </div>);
        const setRight =(<div className={'margin-bottom-10'}>
            <ExportBtn authName="Order-Sale-Export-Button" onClick={() => {this.setState({showExportModal: true})}}></ExportBtn>
        </div>)
        const currPageName = Lang({id: "PoDanLieBiao",default: "订单列表"});
        return (<PageCommon onRef={this.onRefPageCommon}>
            <Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className="dataStatistics-sale">
                    <Tabs defaultActiveKey={auditStatus}
                          onChange={(activeKey)=>this.changeTab(activeKey)}
                          items={[
                              {
                                  key: '1',
                                  label:Lang({id: 'JinXingZhong', default: '进行中'}),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columns}
                                                      rowKey={'poId'}
                                                      fetchCallBack={(data)=>this.fetchCallBack(data)}
                                                      onRef={this.onRefTabOne}
                                                      pageSize={50}
                                                      searchFormOptions={searchFormOptionsOne}
                                                      precondition={{
                                                          type:Number(auditStatus),
                                                          isChangeQuery:selectSeven?1:0,
                                                          noCertificateSplit:noCertificateSplit?1:""
                                                      }}
                                                      scroll={{x:1550,}}
                                                      searchReset={()=>this.searchReset()}
                                                      fetchApi={'/service/mg/statistics/sale-data'}>
                                          {setRightOne}
                                      </AutoFetchTable>
                                  </div>)
                              },{
                                  key: '2',
                                  label:Lang({id: 'YiWanCheng', default: '已完成'}),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columnsReviewed}
                                              onRef={this.onRefTabTwo}
                                              topSearchRightCont={setRight}
                                                      fetchCallBack={(data)=>this.fetchCallBack(data)}
                                              searchFormOptions={searchFormOptionsTwo}
                                              rowKey={'poId'}
                                              pageSize={50}
                                              // initFetch={false}
                                              scroll={{x:1550,}}
                                              precondition={{
                                                  type:Number(auditStatus),
                                              }}
                                                fetchApi={'/service/mg/statistics/sale-data'}  />
                                  </div>)
                              },{
                                  key: '3',
                                  label:Lang({id: 'ChuHuoHouQuXiao', default: '出货后取消'}),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columnsCancel}
                                                      onRef={this.onRefCancelTab}
                                                      fetchCallBack={(data)=>this.fetchCallBack(data)}
                                                      searchFormOptions={searchFormOptionsThree}
                                                      rowKey={'poId'}
                                                      pageSize={50}
                                                      // initFetch={false}
                                                      fetchApi={'/service/mg/cancel-register/list'}  />
                                  </div>)
                              }
                          ]}
                    >
                    </Tabs>
                </div>
                <ExportData isModalVisible={this.state.showExportModal} showSwich={(isShow) => {this.setState({showExportModal: isShow})}}></ExportData>
            </Spin>
        </PageCommon> )
    }
}

export default OrderSale;
